import Tool, {
  type ToolArgsWithController,
  type ToolArgs,
} from '../../../tools/Tool';
import { Transforms } from 'slate';
import TableUtils from '../TableUtils';
import { isTableElement } from '../../../types/guards';

// Reset table column widths
class ToolResetColumnWidths extends Tool {
  static toolName = 'Reset column widths';
  static iconClass = 'fa-regular fa-arrows-left-right-to-line';

  static action({ editor }: ToolArgsWithController): void {
    if (!editor.selection) return;

    const tableEntry = TableUtils.currentTable(editor);
    if (!tableEntry) return;

    if (!Object.hasOwn(tableEntry[0], 'table_columnWidths')) {
      return;
    }

    Transforms.unsetNodes(editor, 'table_columnWidths', {
      at: tableEntry[1],
    });
  }

  static isEnabled({ editor, element }: ToolArgs): boolean {
    if (!editor?.selection) return false;

    return Boolean(
      element && isTableElement(element) && element.table_columnWidths
    );
  }
}

export default ToolResetColumnWidths;
